module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_f_leucistic.7dfa84b9.png";